module.exports = __webpack_public_path__ + "static/media/alishan5.ddd2e6c9.webp";